import { IServiceProvider } from 'angular';
import { UiRouterTitleService } from './ui.router-title.service';

export class UiRouterTitleProvider implements IServiceProvider {
  private titleToken = '$title';
  private defaultTitle = 'My Application';
  private suffix = 'My Application';

  constructor() {
  }

  setTitleToken( token: string ) {
    this.titleToken = token;
  }

  setDefaultTitle( title: string ) {
    this.defaultTitle = title;
  }

  setSuffix( suffix: string ) {
    this.suffix = suffix;
  }

  $get() {
    return new UiRouterTitleService(this.defaultTitle, this.suffix, this.titleToken);
  }
}



// WEBPACK FOOTER //
// ./app/shared/directives/ui-router-title/ui.router-title.provider.ts